import { motion } from 'framer-motion';
import {
  Target,
  Users,
  Sparkles,
  TrendingUp,
  XCircle,
  ArrowRight,
} from 'lucide-react';

export default function ProfileCard({ profile }) {
  if (!profile) return null;

  const creatorProfile = profile.creatorProfile || {};
  const currentDesire = profile.currentDesire || {};

  const sections = [
    {
      icon: Target,
      title: 'Current Intent',
      content: currentDesire.intent_label,
      description: currentDesire.intent_description,
    },
    {
      icon: Users,
      title: 'Looking to Connect With',
      items: currentDesire.desired_people,
    },
    {
      icon: Sparkles,
      title: 'Desired Traits',
      items: currentDesire.desired_traits,
    },
    {
      icon: TrendingUp,
      title: 'Priority Factors',
      items: currentDesire.priority_factors,
    },
    {
      icon: XCircle,
      title: 'Not Looking For',
      items: currentDesire.avoid_traits,
    },
    {
      icon: ArrowRight,
      title: 'Preferred Next Step',
      content: currentDesire.preferred_next_step,
    },
    {
      icon: Users,
      title: 'Creator Type',
      content: creatorProfile.creator_type,
    },
    {
      icon: Sparkles,
      title: 'Content Topics',
      items: creatorProfile.content_topics,
    },
    {
      icon: TrendingUp,
      title: 'Interaction Style',
      items: creatorProfile.interaction_style,
    },
    {
      icon: XCircle,
      title: 'General Boundaries',
      items: creatorProfile.general_boundaries,
    },
  ];

  console.log('ProfileCard sections:', creatorProfile);

  return (
    <div className="grid gap-4 md:grid-cols-2">
      {sections.map((section, index) => {
        const hasContent = section.content || (section.items && section.items.length > 0);
        if (!hasContent) return null;

        const Icon = section.icon;

        return (
          <motion.div
            key={section.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm"
          >
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-lg bg-boggler-teal/10 flex items-center justify-center">
                <Icon size={18} className="text-boggler-teal" />
              </div>
              <h3 className="font-semibold text-gray-800">{section.title}</h3>
            </div>

            {section.content && (
              <p className="text-gray-600 text-sm">{section.content}</p>
            )}

            {section.description && (
              <p className="text-gray-500 text-xs mt-1">{section.description}</p>
            )}

            {section.items && section.items.length > 0 && (
              <div className="flex flex-wrap gap-2 mt-2">
                {section.items.map((item, i) => (
                  <span
                    key={i}
                    className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full"
                  >
                    {item}
                  </span>
                ))}
              </div>
            )}
          </motion.div>
        );
      })}
    </div>
  );
}
